import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentConfig } from '../../../shared/interfaces/environment.interface';
import {
  GetEligibleSuppliers,
  PurePriceCPI,
  PurePriceCPIPayload,
} from '../../shared/interfaces/pricing.interface';

@Injectable({
  providedIn: 'root',
})
export class PricingService {
  private readonly _baseUrl = this._env.environment.pureSpectrum.url;

  constructor(
    private readonly _http: HttpClient,
    @Inject('ENV') private _env: EnvironmentConfig
  ) {}

  public getEligibleSuppliers(
    countryCode: string,
    languageShort: string,
    LOI: string,
    incidence: string,
    incl_excl: string,
    isPurePriceRateCardEnable: boolean,
    surveyFieldTime: string,
    buyer_id?: number
  ) {
    const params = this._getSuppliersParams(
      countryCode,
      languageShort,
      LOI,
      incidence,
      incl_excl,
      isPurePriceRateCardEnable,
      surveyFieldTime,
      buyer_id
    );
    return this._http.get<GetEligibleSuppliers>(
      `${this._baseUrl}/pricingService?${params}`
    );
  }

  private _getSuppliersParams(
    countryCode: string,
    languageShort: string,
    LOI: string,
    incidence: string,
    incl_excl: string,
    isPurePriceRateCardEnable: boolean,
    surveyFieldTime: string,
    buyer_id?: number
  ) {
    let params = new HttpParams();
    params = params.set('countryCode', countryCode);
    params = params.set('languageCode', languageShort);
    params = params.set('LOI', LOI);
    params = params.set('incidence', incidence);
    params = params.set('incl_excl', incl_excl);
    params = params.set(
      'is_pure_price_rate_card_enable',
      isPurePriceRateCardEnable
    );
    params = params.set('source', 'buyerAPI');
    params = params.set('fieldTime', surveyFieldTime);
    if (buyer_id) {
      params = params.set('buyer_id', buyer_id);
    }
    return params;
  }

  getPurePriceBuyerCpi(surveyId: number, payload: PurePriceCPIPayload) {
    return this._http.post<PurePriceCPI>(
      `${this._baseUrl}/buyers/v2/surveys/${surveyId}/pure-price-cpi`,
      payload
    );
  }
}
